
import http from 'helpers/APIHelper';
import { getSessionByKey } from 'helpers';
import { suffixPending, suffixFulfilled, suffixRejected } from 'actions';

export const MODAL_POPUP_ACTIONS = {
  OPEN_MODAL_POPUP: '@showModalPopup',
  CLOSE_MODAL_POPUP: '@closeModalPopup'
};

export const SITES_ACTIONS = {
  GET_ALL_SITES: '@getAllSites'
};

export const COUNTRIES_ACTIONS = {
  GET_COUNTRIES: '@getCountries',
  SET_COUNTRY: '@setCountry'
};

export const openModal = props => ({
  type: MODAL_POPUP_ACTIONS.OPEN_MODAL_POPUP,
  payload: {
    data: props.data,
    type: props.type,
    title: props.title,
    modalSize: props.modalSize
  }
});

export const closeModal = () => ({
  type: MODAL_POPUP_ACTIONS.CLOSE_MODAL_POPUP,
  payload: {}
});


export const getCountries = (token, loggerInfo) => dispatch => {
  dispatch({
    type: COUNTRIES_ACTIONS.GET_COUNTRIES + suffixPending
  });
  http
    .getWithToken(
      `esys-data-service/${
        getSessionByKey('esys_url_ver')
      }/esys/countries`,
      token,
      loggerInfo
    )
    .subscribe(
      resp => {
        dispatch({
          type: COUNTRIES_ACTIONS.GET_COUNTRIES + suffixFulfilled,
          payload: resp.response
        });
      },
      error => {
        dispatch({
          type: COUNTRIES_ACTIONS.GET_COUNTRIES + suffixRejected,
          payload: error
        });
      }
    );
};

export const getAllSites = (token, loggerInfo) => dispatch => {
  dispatch({
    type: SITES_ACTIONS.GET_ALL_SITES + suffixPending
  });
  http
    .postWithToken(
      `site-data-service/${
        getSessionByKey('site_url_ver')
      }/sites/type/ALL`,
      token,
      loggerInfo
    )
    .subscribe(resp => {
      dispatch({
        type: SITES_ACTIONS.GET_ALL_SITES + suffixFulfilled,
        payload: resp.response
      });
    },
    error => {
      dispatch({
        type: SITES_ACTIONS.GET_ALL_SITES + suffixRejected,
        payload: error
      });
    });
};

export const setUserPreferenceByKey = (token, loggerInfo, key, value) => dispatch => {
  http
    .PUT(
      `core-service/${getSessionByKey('prt_url_ver')}/core/value/${key}`,
      loggerInfo,
      value
    )
    .subscribe();
};
